export const createAuditControlMutation = () => {
    return `
    mutation CreateAuditControl(
        $companyId: Int!, 
        $entityId: Int!, 
        $objectiveId: Int!, 
        $mainSystemId: Int!, 
        $hrSystemId: Int, 
        $ticketSystemId: Int, 
        $overwriteControlId: Int, 
        $consolidationJson: JSONString,
        $auditId: Int!, 
        $controlOwnerId: NonEmptyString!
    ) {
        createAuditControl(
            companyId: $companyId, 
            entityId: $entityId, 
            objectiveId: $objectiveId, 
            mainSystemId: $mainSystemId, 
            hrSystemId: $hrSystemId, 
            ticketSystemId: $ticketSystemId, 
            overwriteControlId: $overwriteControlId, 
            consolidationJson: $consolidationJson, 
            auditId: $auditId, 
            controlOwnerId: $controlOwnerId
        ) {
            auditControl {
                id
                control {
                    id
                }
            }
        }
    }      
    `
}